import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SearchbarComponent } from './searchbar/searchbar.component';
import { MultiSelectComponent } from './multi-select/multi-select.component';
import { ToggleButtonComponent } from './toggle-button/toggle-button.component';
import {AtomsModule} from "../atoms/atoms.module";
import { SelectOverlayComponent } from './select-overlay/select-overlay.component';
import { SchoolSubjectsFilterComponent } from './school-subjects-filter/school-subjects-filter.component';
import { SchoolSubjectsFilterFooterComponent } from './school-subjects-filter/school-subjects-filter-footer/school-subjects-filter-footer.component';
import { CheckboxFilterComponent } from './checkbox-filter/checkbox-filter.component';
import { CheckboxTreeFilterComponent } from './checkbox-tree-filter/checkbox-tree-filter.component';
import { CheckboxTreeFilterGroupComponent } from './checkbox-tree-filter/checkbox-tree-filter-group/checkbox-tree-filter-group.component';
import { GroupedCheckboxFilterComponent } from './grouped-checkbox-filter/grouped-checkbox-filter.component';
import { DirectivesModule } from "../directives/directives.module";
import {FormsModule} from "@angular/forms";
import { SearchFilterFooterComponent } from './search-filter-footer/search-filter-footer.component';
import { SearchLocationComponent } from './search-location/search-location.component';
import { SearchLocationFilterComponent } from './search-location/search-location-filter/search-location-filter.component';
import {ToggleCheckboxComponent} from "./toggle-checkbox/toggle-checkbox.component";
import { DistanceFilterComponent } from './distance-filter/distance-filter.component';
import { SearchLocationFilterFooterComponent } from './search-location/search-location-filter/search-location-filter-footer/search-location-filter-footer.component';
import {SwiperModule} from "swiper/angular";
import { GlobalSearchOverlayComponent } from './global-search-overlay/global-search-overlay.component';
import { GlobalSearchOverlayResultComponent } from './global-search-overlay/global-search-overlay-result/global-search-overlay-result.component';
import {RouterLink} from "@angular/router";



@NgModule({
    declarations: [
        SearchbarComponent,
        MultiSelectComponent,
        ToggleButtonComponent,
        SelectOverlayComponent,
        SchoolSubjectsFilterComponent,
        SchoolSubjectsFilterFooterComponent,
        CheckboxFilterComponent,
        CheckboxTreeFilterComponent,
        CheckboxTreeFilterGroupComponent,
        GroupedCheckboxFilterComponent,
        SearchFilterFooterComponent,
        SearchLocationComponent,
        SearchLocationFilterComponent,
        ToggleCheckboxComponent,
        DistanceFilterComponent,
        SearchLocationFilterFooterComponent,
        GlobalSearchOverlayComponent,
        GlobalSearchOverlayResultComponent,
    ],
    exports: [
        SearchbarComponent,
        ToggleButtonComponent,
        MultiSelectComponent,
        SearchLocationComponent,
        ToggleCheckboxComponent,
        DistanceFilterComponent,
        CheckboxFilterComponent,
        SchoolSubjectsFilterComponent,
        GroupedCheckboxFilterComponent,
        CheckboxTreeFilterComponent,
        SearchLocationFilterComponent,
        GlobalSearchOverlayComponent
    ],
    imports: [
        CommonModule,
        AtomsModule,
        DirectivesModule,
        FormsModule,
        SwiperModule,
        RouterLink,
    ]
})
export class SearchFilterModule { }
